// import Payment from 'payment';
import {
  differenceInMinutes,
  differenceInHours,
  differenceInDays,
  parseISO,
  differenceInYears,
} from 'date-fns';
import i18n from './i18n';

import bankingInstitutions from '../bankingInstitutions.json'

export const getUrlParamValue = (param: string) => {
  const urlParams = new URLSearchParams(window.location.search);

  const paramValue = urlParams.get(param);

  return paramValue;
};

function clearNumber(value = '') {
  return value.replace(/\D+/g, '');
}

// TODO REMOVE

// export function formatCreditCardNumber(value?: any) {
//   if (!value) {
//     return value;
//   }

//   const issuer = Payment.fns.cardType(value);
//   const clearValue = clearNumber(value);
//   let nextValue;

//   switch (issuer) {
//     case 'amex':
//       nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
//         4,
//         10
//       )} ${clearValue.slice(10, 15)}`;
//       break;
//     case 'dinersclub':
//       nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
//         4,
//         10
//       )} ${clearValue.slice(10, 14)}`;
//       break;
//     default:
//       nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
//         4,
//         8
//       )} ${clearValue.slice(8, 12)} ${clearValue.slice(12, 19)}`;
//       break;
//   }

//   return nextValue.trim();
// }

// TODO REMOVE

// export function formatCVC(
//   value: string,
//   prevValue?: any,
//   allValues = { number: '' }
// ) {
//   const clearValue = clearNumber(value);
//   let maxLength = 4;

//   if (allValues.number) {
//     const issuer = Payment.fns.cardType(allValues.number);
//     maxLength = issuer === 'amex' ? 4 : 3;
//   }

//   return clearValue.slice(0, maxLength);
// }

export function formatExpirationDate(value: any) {
  const clearValue = clearNumber(value);

  if (clearValue.length >= 3) {
    return `${clearValue.slice(0, 2)}/${clearValue.slice(2, 4)}`;
  }

  return clearValue;
}

export function formatFormData(data: any) {
  return Object.keys(data).map((d) => `${d}: ${data[d]}`);
}

export const formatCurrency = (value: number) => {
  if (value) {
    return value.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      style: 'currency',
      currency: 'BRL',
    });
  }

  return 'R$ 0,00';
};

export const formatPostDate = (createdAt: string) => {
  if (!createdAt) return '';

  const parsedDate = parseISO(createdAt);
  const currentDate = new Date();

  const minutesDiff = differenceInMinutes(currentDate, parsedDate);
  const hoursDiff = differenceInHours(currentDate, parsedDate);
  const daysDiff = differenceInDays(currentDate, parsedDate);

  if (minutesDiff < 1) {
    return i18n.t('PostView.time.now');
  } else if (minutesDiff === 1) {
    return `${minutesDiff} ${i18n.t('PostView.time.minuteSingle')}`;
  } else if (minutesDiff < 60) {
    return `${minutesDiff} ${i18n.t('PostView.time.minutePlural')}`;
  } else if (hoursDiff < 24) {
    return `${hoursDiff} ${i18n.t('PostView.time.hoursPlural')}`;
  } else if (daysDiff === 1) {
    return `${daysDiff} ${i18n.t('PostView.time.daySingle')}`;
  } else if (daysDiff > 31) {
    return `${Math.round(daysDiff / 30)} ${i18n.t('PostView.time.monthPlural')}`;
  } else {
    return `${daysDiff} ${i18n.t('PostView.time.dayPlural')}`;
  }
};

export const formatLikes = (likes: number) => {
  if (!likes) return '';

  return likes;
};

export const countries = [
  { label: 'Afghanistan', value: 'AF' },
  { label: 'Albania', value: 'AL' },
  { label: 'Algeria', value: 'DZ' },
  { label: 'Andorra', value: 'AD' },
  { label: 'Angola', value: 'AO' },
  { label: 'Antigua and Barbuda', value: 'AG' },
  { label: 'Argentina', value: 'AR' },
  { label: 'Armenia', value: 'AM' },
  { label: 'Australia', value: 'AU' },
  { label: 'Austria', value: 'AT' },
  { label: 'Azerbaijan', value: 'AZ' },
  { label: 'Bahamas', value: 'BS' },
  { label: 'Bahrain', value: 'BH' },
  { label: 'Bangladesh', value: 'BD' },
  { label: 'Barbados', value: 'BB' },
  { label: 'Belarus', value: 'BY' },
  { label: 'Belgium', value: 'BE' },
  { label: 'Belize', value: 'BZ' },
  { label: 'Benin', value: 'BJ' },
  { label: 'Bhutan', value: 'BT' },
  { label: 'Bolivia', value: 'BO' },
  { label: 'Bosnia and Herzegovina', value: 'BA' },
  { label: 'Botswana', value: 'BW' },
  { label: 'Brazil', value: 'BR' },
  { label: 'Brunei Darussalam', value: 'BN' },
  { label: 'Bulgaria', value: 'BG' },
  { label: 'Burkina Faso', value: 'BF' },
  { label: 'Burundi', value: 'BI' },
  { label: 'Cabo Verde', value: 'CV' },
  { label: 'Cambodia', value: 'KH' },
  { label: 'Cameroon', value: 'CM' },
  { label: 'Canada', value: 'CA' },
  { label: 'Central African Republic', value: 'CF' },
  { label: 'Chad', value: 'TD' },
  { label: 'Chile', value: 'CL' },
  { label: 'China', value: 'CN' },
  { label: 'Colombia', value: 'CO' },
  { label: 'Comoros', value: 'KM' },
  { label: 'Congo', value: 'CG' },
  { label: 'Congo, Democratic Republic of the', value: 'CD' },
  { label: 'Costa Rica', value: 'CR' },
  { label: 'Croatia', value: 'HR' },
  { label: 'Cuba', value: 'CU' },
  { label: 'Cyprus', value: 'CY' },
  { label: 'Czech Republic', value: 'CZ' },
  { label: 'Denmark', value: 'DK' },
  { label: 'Djibouti', value: 'DJ' },
  { label: 'Dominica', value: 'DM' },
  { label: 'Dominican Republic', value: 'DO' },
  { label: 'Ecuador', value: 'EC' },
  { label: 'Egypt', value: 'EG' },
  { label: 'El Salvador', value: 'SV' },
  { label: 'Equatorial Guinea', value: 'GQ' },
  { label: 'Eritrea', value: 'ER' },
  { label: 'Estonia', value: 'EE' },
  { label: 'Eswatini', value: 'SZ' },
  { label: 'Ethiopia', value: 'ET' },
  { label: 'Fiji', value: 'FJ' },
  { label: 'Finland', value: 'FI' },
  { label: 'France', value: 'FR' },
  { label: 'Gabon', value: 'GA' },
  { label: 'Gambia', value: 'GM' },
  { label: 'Georgia', value: 'GE' },
  { label: 'Germany', value: 'DE' },
  { label: 'Ghana', value: 'GH' },
  { label: 'Greece', value: 'GR' },
  { label: 'Grenada', value: 'GD' },
  { label: 'Guatemala', value: 'GT' },
  { label: 'Guinea', value: 'GN' },
  { label: 'Guinea-Bissau', value: 'GW' },
  { label: 'Guyana', value: 'GY' },
  { label: 'Haiti', value: 'HT' },
  { label: 'Honduras', value: 'HN' },
  { label: 'Hungary', value: 'HU' },
  { label: 'Iceland', value: 'IS' },
  { label: 'India', value: 'IN' },
  { label: 'Indonesia', value: 'ID' },
  { label: 'Iran', value: 'IR' },
  { label: 'Iraq', value: 'IQ' },
  { label: 'Ireland', value: 'IE' },
  { label: 'Israel', value: 'IL' },
  { label: 'Italy', value: 'IT' },
  { label: 'Jamaica', value: 'JM' },
  { label: 'Japan', value: 'JP' },
  { label: 'Jordan', value: 'JO' },
  { label: 'Kazakhstan', value: 'KZ' },
  { label: 'Kenya', value: 'KE' },
  { label: 'Kiribati', value: 'KI' },
  { label: 'Kuwait', value: 'KW' },
  { label: 'Kyrgyzstan', value: 'KG' },
  { label: "Lao People's Democratic Republic", value: 'LA' },
  { label: 'Latvia', value: 'LV' },
  { label: 'Lebanon', value: 'LB' },
  { label: 'Lesotho', value: 'LS' },
  { label: 'Liberia', value: 'LR' },
  { label: 'Libya', value: 'LY' },
  { label: 'Liechtenstein', value: 'LI' },
  { label: 'Lithuania', value: 'LT' },
  { label: 'Luxembourg', value: 'LU' },
  { label: 'Madagascar', value: 'MG' },
  { label: 'Malawi', value: 'MW' },
  { label: 'Malaysia', value: 'MY' },
  { label: 'Maldives', value: 'MV' },
  { label: 'Mali', value: 'ML' },
  { label: 'Malta', value: 'MT' },
  { label: 'Marshall Islands', value: 'MH' },
  { label: 'Mauritania', value: 'MR' },
  { label: 'Mauritius', value: 'MU' },
  { label: 'Mexico', value: 'MX' },
  { label: 'Micronesia (Federated States of)', value: 'FM' },
  { label: 'Moldova', value: 'MD' },
  { label: 'Monaco', value: 'MC' },
  { label: 'Mongolia', value: 'MN' },
  { label: 'Montenegro', value: 'ME' },
  { label: 'Morocco', value: 'MA' },
  { label: 'Mozambique', value: 'MZ' },
  { label: 'Myanmar', value: 'MM' },
  { label: 'Namibia', value: 'NA' },
  { label: 'Nauru', value: 'NR' },
  { label: 'Nepal', value: 'NP' },
  { label: 'Netherlands', value: 'NL' },
  { label: 'New Zealand', value: 'NZ' },
];

export const gendersData = [
  { value: 'male' },
  { value: 'female' },
  { value: 'none' }
];

export const bankingInstitutionsData = bankingInstitutions.map((bank) => ({
  value: bank.value,
}));

export const pronounsData = [
  { value: 'he' },
  { value: 'she' },
];

export const statesData = [
  { value: 'AC' },
  { value: 'AL' },
  { value: 'AP' },
  { value: 'AM' },
  { value: 'BA' },
  { value: 'CE' },
  { value: 'DF' },
  { value: 'ES' },
  { value: 'GO' },
  { value: 'MA' },
  { value: 'MT' },
  { value: 'MS' },
  { value: 'MG' },
  { value: 'PA' },
  { value: 'PB' },
  { value: 'PR' },
  { value: 'PE' },
  { value: 'PI' },
  { value: 'RJ' },
  { value: 'RN' },
  { value: 'RS' },
  { value: 'RO' },
  { value: 'RR' },
  { value: 'SC' },
  { value: 'SP' },
  { value: 'SE' },
  { value: 'TO' }
]

export const isMinor = (dateOfBirth: string) => {
  const dob = parseISO(dateOfBirth);
  const age = differenceInYears(new Date(), dob);

  return age < 18;
};

export const isMobile = () => {
  return (
    navigator.userAgent.indexOf('iPhone') !== -1 ||
    /Android/i.test(navigator.userAgent)
  );
};

export const copyToClipboard = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
    console.log("Text copied successfully!");
  } catch (err) {
    console.error("Failed to copy: ", err);
  }
}
